import * as React from 'react';
import cx from 'classnames';

// Hooks
import { useTranslation } from '@shopee-user/platform';

import styles from './style.scss';

export default function AccountPasswordRules({
  hasError = false,
  className = null,
}: {
  hasError?: boolean;
  className?: string | null;
}) {
  const I18n = useTranslation();

  return (
    <div className={cx(className, hasError ? styles.hasError : null)}>
      <div>{I18n.t('msg_account_password_must_be_long')}</div>
      <div>{I18n.t('msg_account_contain_uppercase_and_lowercase')}</div>
    </div>
  );
}
